import { HomeState } from "../types";

export const initialState: HomeState = {
  loading: false,
  statusItems: [],
  summaryCards: [],
  vehicles: [],
  scheduleExceptions: [],
  engineeringAlerts: [],
};
